import { render, staticRenderFns } from "./ArrowDown.vue?vue&type=template&id=421a5897"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"
import style0 from "./ArrowDown.vue?vue&type=style&index=0&id=421a5897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports